const locale = {
	OVERVIEW: "Overview",
	BUSINESSSUITESETTINGS: "Business Suite Settings",
	USERMANAGEMENT: "Usermanagement",
	COMPANYSETTINGS: "Company settings",
	FILESIZETOOBIG: "This file is too big!",
	COMPANYLOGO: "Companylogo",
	COMPANYNAME: "Companyname",
	COMPANYSHORTNAME: "Company shortname",
	SAVE: "Save",
	YES: "Yes",
	NO: "No",
	CANCEL: "Cancel",
	CLOSE: "Close",
	SUCCESS: "Success",
	QUITWITHOUTSAVING: "Do you really want to leave without saving?",
	ATTENTION: "Attention",
	COMPANYWIDESETTINGS: "Cooperatewide settings",
	YOUDONTHAVEADMINRIGHTS: "You currently dont have any administrative rights",
	USERSETTINGS: "Usersettings",
	DEFAULTUSERSETTINGS: "Default User Settings",
	TLSETTINGS: "TimeLite Settings",
	USEREMAIL: "E-Mail",
	USERPHONE: "Phone",
	USERPASSWORD: "Password",
	CHANGEPASSWORD: "Change password",
	SECURITY: "Security",
	CONTACTINFORMATION: "Contact Information",
	APPEARANCE: "Appearance",
	CHANGECOLOR: "Change Profile Color",
	SELECTCOLOR: "Select Profile Color",
	ALL: "All",
	ROWSPERPAGE: "Rows per page",
	OF: "of",
	QUICKSEARCH: "Quick search",
	NOUSERSFOUND: "We couldn't find matching users, sorry",
	FIRSTNAME: "First Name",
	LASTNAME: "Last Name",
	USERNAME: "Username",
	EMAIL: "EMail",
	PHONE: "Phone",
	STATUS: "Status",
	LASTONLINE: "Last online",
	DEACTIVE: "Deactive",
	ACTIVE: "Normal",
	DELETED: "Deleted",
	LOCKEDOUT: "Locked out",
	NEVER: "Never",
	UNLOCK: "Unlock",
	DISABLE: "Deactivate",
	ENABLE: "Activate",
	DELETE: "Delete",
	RESETPASSWORD: "Reset password",
	IMPERSONATE_USER: "Impersonate user",
	CREATEUSER: "Create user",
	EDITUSER: "Edit user",
	BASEINFOS: "Baseinfos",
	LICENCES: "Licences",
	ADMINROLES: "Adminroles",
	METADATA: "Metadata",
	FIRSTNAME: "Firstname",
	FIRSTNAME2: "2. Firstname",
	LASTNAME: "Lastname",
	PRETITLE: "Pre-Title",
	POSTTITLE: "Post-Title",
	BIRTHDATE: "Birthdate",
	CANCHANGEPASSWORD: "Can change password",
	COMMENT: "Comment",
	COUNTRY: "Country",
	PROVINCE: "Province/Region",
	POSTALCODE: "Postal code",
	CITY: "City",
	STREET: "Street",
	ADDRESSADDITION: "Addressaddition",
	NEWPASSWORD: "New password",
	NEWPASSWORDCONFIRM: "Repeat new password",
	FIELDREQUIRED: "This field is required",
	INVALIDINPUT: "Your input contains invalid characters",
	PASSWORDSMUSTMATCH: "Passwords do not match",
	IVALIDEMAILFORMAT: "Invalid Email format",
	IVALIDEPHONEFORMAT: "Invalid phone format",
	USERCREATEDAT: "User was created at",
	CREATEDOF: "of",
	UNKNOWN: "Unknown",
	ROLENAME: "Rolename",
	ROLEWEIGHT: "Weighting",
	ROLEDESCRIPTION: "Description",
	ASSIGNEDUSERS: "Assigned",
	ADDTHISUSER: "Add",
	REMOVETHISUSER: "Remove",
	DEFAULT: "Default",
	ALLASSIGNED: "All assigned",
	DELETEQUESTION: "Do you really want to proceed with the deletion?",
	PASSWORDRESETQUESTION: "If you continue, the selected users will receive an email with further instructions on how to reset their password. Proceed?",
	PASSWORTREQUESTDONE: "Password reset emails have been sent.",
	ADMINISTRATION: "Administration",
	MANAGEWORKMODES: "Workmodes",
	WORKMODEHASASSIGNMENTS: "Calculation-related settings can only be changed when this workmode has no assignments.",
	WORKMODEHASASSIGNMENTSCANNOTDELETE: "This workmode has assignments and cannot be deleted.",
	WORKMODE: "Workmode",
	ALLUSERS: "All users",
	NOENDDATE: "No end date",
	CREATEWORKMODE: "Create workmode",
	EDITWORKMODE: "Edit workmode",
	COPYWORKMODE: "Copy workmode",
	DELETEWORKMODE: "Delete workmode",
	WORKMODEDELETEQUESTION: "Delete the workmode {{status}}?",
	DELETEASSIGNMENT: "Delete assignment",
	COPYASSIGNMENT: "Copy assignment",
	ASSIGNMENTDELETEQUESTION: "Delete this assignment?",
	NOMATCHINGENTRIES: "No matching entries.",
	RELOAD: "Reload",
	LOADINGWORKMODES: "Loading workmodes",
	WORKMODESLOADFAILED: "The workmodes could not be loaded. Please reload.",
	USEWORKMODEDEFAULT: "Use workmode default",
	WORKMODEINHERITHELP: "Inherited values come from the workmode definition. Zero is an explicit override.",
	SECONDS: "Seconds",
	IDENTITYANDDISPLAY: "Identity and display",
	ACTIVITYBEHAVIOR: "Activity behavior",
	REQUESTDEFAULTS: "Request defaults",
	DURATIONLEADANDFOLLOWUPLIMITS: "Duration, lead and follow-up limits",
	ROUNDING: "Rounding",
	ACTIVITYDESCRIPTIONS: "Activity descriptions",
	STATUSID: "Workmode ID",
	STATUSBEZEICHNUNG: "Name",
	STATUSGROUP: "Group",
	ACTIVEPRESENCE: "Active presence",
	INACTIVEPRESENCE: "Inactive presence",
	PASSIVEPRESENCE: "Passive presence",
	ABSENCE: "Absence",
	VACATION: "Vacation",
	EXEMPTION: "Exemption",
	SORTINGNUMBER: "Sort order",
	LIVESTART: "Live clock-in",
	LIVEEND: "Live clock-out",
	MUSTBEINSIDE: "Required time window",
	PAID: "Paid",
	REPORTPOINTOUT: "Highlight in reports",
	OFFSETTINGMETHOD: "Calculation method",
	UNIT: "Unit",
	ADVISEDUNIT: "Suggested unit",
	MINIMALVALID: "Minimum valid duration",
	MOREDAYSALLOW: "Allow multiple days",
	MOREDAYSFILL: "Fill multiple days with",
	AUTOENDONLIVE: "Automatically end live activity after",
	MAXPLAINCOUNTINGDURATIONSINGLE: "Maximum allowed duration per activity",
	MAXPLAINCOUNTINGDURATIONDAY: "Maximum allowed duration per day",
	MAXDURATIONOPEN: "Maximum open duration",
	LEADTIME: "Maximum lead time",
	LEADTIMENEG: "Maximum negative lead time",
	LEADTIMEMAN: "Allow manual lead time",
	FOLLOWUPTIME: "Maximum follow-up time",
	FOLLOWUPTIMENEG: "Maximum negative follow-up time",
	FOLLOWUPTIMEMAN: "Allow manual follow-up time",
	ROUNDEDTIMEBEGINMODE: "Round activity start",
	ROUNDEDTIMEENDMODE: "Round activity end",
	ACTIVITYDESCRIPTIONWITHOUT: "Description without a project",
	ACTIVITYDESCRIPTIONWITHPROJECT: "Description with a project",
	REQUESTONLIVESTART: "Require request for clock-in",
	REQUESTONLIVEEND: "Require request for clock-out",
	REQUESTONLIVEOFFLINE: "Require request for offline clocking",
	REQUESTONCREATE: "Require request for creation",
	REQUESTONEDIT: "Require request for editing",
	REQUESTONDELETE: "Require request for deletion",
	REQUESTONOUTSIDEFLEX: "Require request outside flex time",
	ROUNDINGINTERVAL: "Interval in minutes",
	DURATIONAMOUNT: "Amount",
	DURATIONUNIT: "Unit",
	DAYOFFSET: "Days after activity start",
	TIMEOFDAY: "Time of day",
	FLEXTIME: "Flex time",
	NORMALWORKINGTIME: "Normal working hours",
	CORETIME: "Core hours",
	TIME: "Time",
	MONEY: "Money",
	HOURS: "Hours",
	HALFDAYS: "Half days",
	DAYS: "Days",
	ALLDAYS: "All days",
	NOTALLOWED: "Not allowed",
	OPTIONAL: "Optional",
	REQUIRED: "Required",
	MANAGEOBJECTS: "Objects",
	TIMELITE: "TimeLite",
	GENERAL: "General",
	SYSTEMSETTINGS: "System settings",
	REPORTSLOGO: "Reportslogo",
	EDITLOGO: "Change logo",
	REMOVELOGO: "Remove logo",
	DEFAULTSYSTEMLANGUAGE: "Default system language",
	MANAGEANNUALPERIODS: "Timetracking periods",
	MANAGEHIERARCHY: "Organigram",
	LIVECLOCKINTYPE: "Live clockin type",
	DIALOG: "Dialog",
	INSTANT: "Instant",
	QUICK: "Quick",
	NEWACTIVITYDEFAULTS: "New activity default selection",
	NOTSET: "Not set",
	LIKELASTACTIVITY: "Like last activity",
	FIXEDSET: "Fixed set",
	DEFAULTSTATUS: "Default workmode",
	DEFAULTOBJECTS: "{{objects}} assignment",
	PREFERREDSUPERVISOR: "Preferred supervisor",
	AUTOANNUALPERIODBEFOREEND: "Timetracking period automatic renew",
	DAYSBEFOREEND: "Days before end",
	ANNUALPERIODS: "Timetracking periods",
	SUPERVISORCHECKMETHOD: "Supervisorcheckmethod",
	LIVEDATE: "Live date",
	ONDATE: "On selected day",
	FROM: "From",
	TO: "To",
	DESCRIPTION: "Description",
	APERIODDELETEQUESTION: "Do you really wish to delete this timetracking period?",
	NEWAPERIOD: "New timetracking period",
	EDITAPERIOD: "Edit timetracking period",
	DELETEAPERIOD: "Delete timetracking period",
	APERIODALREADYENDED: "This period has already ended and cannot be edited",
	APERIODALREADYSTARTED: "This period has already started and cannot be deleted",
	APERIODSERVERUNKNOWN: "Server date is unknown, cannot create period",
	EMPLOYEDDATE: "Employed date",
	INITIALEMPLOYEDDATE: "Initial employment date",
	SEARCH: "Search",
	HIERARCHYLEFTHEADERTEXT: "Current company structure",
	HIERARCHYRIGHTHEADERTEXT: "Available users / groups",
	HIERARCHYFILLINGERROR: "While filling in the structure, an error occured",
	HIERARCHYDRAGNOTVALID: "This location is not valid for user",
	HIERARCHYROLESETTINGS: "Role settings",
	SUPERIORROLE: "Superior role",
	UPWARDSINHERITANCE: "Allow access to employee for higher-level supervisors",
	DOWNWARDSINHERITANCE: "Allow access for supervisors to lower-level employees",
	ROLEPASSDOWN: "Pass permissions to lower-level employees",
	COMPANYSTRUCTURE: "Company structure",
	ASSIGNED: "Assigned",
	HIERARCHYROLES: "Hierarchy roles",
	MANAGEHIERARCHYROLES: "Manage hierarchy roles",
	CREATEHIERARCHYROLE: "Create hierarchy role",
	EDITHIERARCHYROLE: "Edit hierarchy role",
	DELETEHIERARCHYROLE: "Delete hierarchy role",
	NEWHIERARCHYROLE: "New hierarchy role",
	HIERARCHYROLEDELETEQUESTION: "Are you sure you want to delete this hierarchy role?",
	ROLENAME: "Role name",
	ROLEIDENTIFIER: "Role identifier",
	ROLENAME: "Role name",
	ROLEDESCRIPTION: "Role description",
	PERMISSIONS: "Permissions",
	CANVIEWSUBCALENDAR: "Can view subordinate calendar",
	CANCREATESUBACTIVITIES: "Can create subordinate activities",
	CANEDITSUBACTIVITIES: "Can edit subordinate activities",
	CANDELETESUBACTIVITIES: "Can delete subordinate activities",
	CANMANAGESUBBALANCECOMP: "Can manage subordinate balance compensation",
	CANVIEWSUBREPORTS: "Can view subordinate reports",
	CANANSWERSUBREQUESTS: "Can answer subordinate requests",
	CANRECEIVESUBREQUESTS: "Can receive subordinate requests",
	CANSEALSUBDAYSORACTIVITIES: "Can seal subordinate days or activities",
	CANVIEWSUBTASKS: "Can view subordinate tasks",
	CANCREATESUBTASKS: "Can create subordinate tasks",
	CANEDITSUBTASKS: "Can edit subordinate tasks",
	CANDELETESUBTASKS: "Can delete subordinate tasks",
	CANCLOSESUBTASKS: "Can close or reopen subordinate tasks",
	ROLEINUSE: "This role is currently assigned to users and cannot be deleted",
	ROLEINUSEPERMISSIONSDISABLED: "Permissions cannot be changed while this role is actively assigned. To modify permissions, unassign all users from this role first.",
	ROLEIDENTIFIEREXISTS: "A role with this identifier already exists",
	NONE: "None",
	COLOR: "Color",
	NOOBJECTASSIGNMENT: "No {{object}} assignment",
	NOOBJECTSFOUND: "No {{objects}} found",
	SELECTIONEXCEEDSMAX: "Selection exceeds the maximum",
	NAME: "Name",
	PLURALNAME: "Pluralname",
	MODE: "Mode",
	ICON: "Icon",
	MAXSELECT: "Max-select",
	SUBENABLED: "Subobjects",
	NEWOBJECT: "New object",
	EDITOBJECT: "Edit object",
	DELETEOBJECT: "Delete object",
	OBJECTHASITEMSCANNOTDELETE: "This object has existing items and cannot be deleted",
	DOABLE: "Doable",
	USABLE: "Usable",
	SETTINGSFOR: "Settings for",
	EXECUTEWEBCRON: "Execute webcron now",
	WEBCRONRUNNING: "Webcron is running now",
	EXKURSIO: "Exkursio",
	TASKSENABLED: "Tasks enabled",
	HOLIDAYMANAGEMENT: "Holiday Management",
	MAINBUSINESSLOCATION: "Main business location",
	QUICKINFOSRECALCAFTER: "Quick infos recalculation interval",
	SECONDSAFTERRECALC: "Seconds after recalc",
	MINUTES: "Minutes",
	TEAMABSENCEVISIBLE: "Team absence visible statuses",
	PEOPLEVISIBILITY: "People visibility",
	PEOPLEVISIBILITY_PRIVATE: "Private",
	PEOPLEVISIBILITY_INFOS: "Infos",
	PEOPLEVISIBILITY_LIVE: "Live",
	PEOPLEVISIBILITY_LIVEDETAIL: "Live Detail",
	PEOPLEVISIBILITY_FULLDAY: "Full Day",
	NORMTIME_SUBTRACT_TIMING: "Today's Normtime Subtraction",
	NORMTIME_SUBTRACT_STARTOFDAY: "Start of Day",
	NORMTIME_SUBTRACT_REALTIME: "Real-time",
	NORMTIME_SUBTRACT_ENDOFDAY: "End of Day",
	GENERAL: "General",
	REPORTSANDBRANDING: "Reports & Branding",
	TIMETRACKINGSETTINGS: "Time Tracking Settings",
	LOCATIONANDVISIBILITY: "Location & Visibility",
	LANGUAGE_DE: "German",
	LANGUAGE_EN: "English",
	HOLIDAYTYPE: "Holiday Type",
	NEWHOLIDAY: "New Holiday",
	EDITHOLIDAY: "Edit Holiday",
	DELETEHOLIDAY: "Delete holiday",
	HOLIDAYDELETEQUESTION: "Do you really wish to delete this holiday?",
	BUSINESSLOCATIONMANAGEMENT: "Business Location Management",
	RELIGIONMANAGEMENT: "Religion Management",
	NEWBUSINESSLOCATION: "New Business Location",
	EDITBUSINESSLOCATION: "Edit Business Location",
	DELETEBUSINESSLOCATION: "Delete business location",
	BUSINESSLOCATIONINUSE: "This location is in use and cannot be deleted",
	NEWRELIGION: "New Religion",
	EDITRELIGION: "Edit Religion",
	DELETERELIGION: "Delete religion",
	RELIGIONINUSE: "This religion is in use and cannot be deleted",
	LOCATIONNAME: "Location Name",
	POSTALCODE: "Postal Code",
	CITY: "City",
	CLEARALLCARRYOVERS: "Clear All Annual Carryovers",
	CLEARALLCARRYOVERSQUESTION: "Are you sure you want to clear all annual carryovers for all users and all periods?",
	CLEARALLCARRYOVERSINFO: "All annual carryovers (including project carryovers) have been cleared.",
	RECALCALLANNUALPERIODS: "Recalculate All Annual Periods",
	RECALCALLANNUALPERIODSINFO: "All balances for all users will be recalculated, this may take a few minutes.",
	ATTENTION: "Attention",
	STREET: "Street",
	ADDRESSADDITION: "Address Addition",
	RELIGIONNAME: "Religion Name",
	BUSINESSLOCATIONDELETEQUESTION: "Do you really wish to delete this business location?",
	RELIGIONDELETEQUESTION: "Do you really wish to delete this religion?",
	PARTDAYTYPE: "Part Day Type",
	PARTDAY_FULL: "Full Day",
	PARTDAY_HALF_START: "Half Day (Start)",
	PARTDAY_HALF_END: "Half Day (End)",
	PARTDAY_HALF_UNTIL: "Half Day Until",
	PARTDAY_HALF_FROM: "Half Day From",
	CUSTOMTIME: "Time (HHMM)",
	CUSTOMTIMEHELPER: "Format: HHMM (e.g. 1200 for 12:00, 1330 for 13:30)",
	VALIDFROM: "Valid From",
	VALIDUNTIL: "Valid Until",
	DATETHISYEAR: "Date This Year",
	RELIGION: "Religion",
	SPECIALDATE: "Special Date",
	SPECIALNAME: "Special Name",
	TOTALBALANCESHOWTYPE: "Total Balance Display Type",
	CURRENTTOTALBALANCE: "Current Total Balance",
	UNTILLASTMONTHTOTALBALANCE: "Total Balance Until End of Last Month",
	UNTILLASTWEEKTOTALBALANCE: "Total Balance Until End of Last Week",
	VACATIONBALANCEROUNDING: "Vacation Balance Rounding",
	ROUNDUP: "Round Up",
	ROUNDDOWN: "Round Down",
	ROUNDNEAREST: "Round to Nearest",
	CANCREATEOBJECTITEMS: "Can Create Object Items",
	CANCREATETASKS: "Can Create Tasks",
	CANMANAGEOWNBALANCECOMP: "Can Manage Own Balance Compensations",
	SEALPOLICY: "Seal Policy",
	UNSEALPOLICY: "Unseal Policy",
	POLICY_FORBIDDEN: "Forbidden",
	POLICY_ALLOW: "Allow",
	POLICY_REQUEST: "Request approval",
	LIVECLOCKINOROUT_TLAPP: "Live Clock In/Out TLApp",
	LIVECLOCKINOROUT_ABSWEB: "Live Clock In/Out ABSWeb",
	LIVECLOCKINOROUT_TLPANEL: "Live Clock In/Out TLPanel",
	CANSEEOWNTOTALBALANCES: "Can See Own Total Balances",
	ACTIVITYDESCRIPTION_SUGGESTIONS: "Activity Description Suggestions",
	ACTIVITYDESCRIPTION_SUGGESTIONS_HELP: "Number of suggestions to show (0 = off)",
	TRIPSUGGESTIONS_LIMIT: "Trip Suggestions Limit",
	TRIPSUGGESTIONS_LIMIT_HELP: "Number of suggestions to show for trip fields (0 = off)",
	INHERITEDFROMDEFAULT: "Inherited from Default",
	USEDEFAULT: "Use Default",
	CLICKTOOVERRIDE: "Click to Override",
	HARDWARE: "Hardware",
	NFCCHIPS: "NFC Chips",
	CHIPID: "Chip ID",
	CHIPNAME: "Chip Name",
	ENABLED: "Enabled",
	SCANCOUNT: "Scan Count",
	LASTSEEN: "Last Seen",
	LASTSEENCHIPTEXT: "Last Seen Chip Text",
	CREATENEWNFCCHIP: "Create New NFC Chip",
	EDITNFCCHIP: "Edit NFC Chip",
	DELETENFCCHIP: "Delete NFC Chip",

	CHIPIDISREQUIRED: "Chip ID is required",
	CHIPNAMEISREQUIRED: "Chip Name is required",
	INVALIDCHIPIDFORMAT: "Invalid Chip ID format",
	CONFIRMDELETECHIPMESSAGE: "Are you sure you want to delete this chip and all its assignments?",
	CHIPHASSCANSCANNOTDELETE: "This chip has existing scan records and cannot be deleted",
	OK: "OK",
	ASSIGNMENTS: "Assignments",
	USERASSIGNMENT: "User Assignment",
	STARTDATE: "Start Date",
	ENDDATE: "End Date",
	ASSIGNEDTO: "Assigned To",
	NOASSIGNMENTS: "No assignments",
	NEWASSIGNMENT: "New Assignment",
	EDITASSIGNMENT: "Edit Assignment",
	SELECTUSER: "Select User",
	UNASSIGNED: "Unassigned",
	SPECIALEFFECTS: "Seasonal Effects",
	SPECIALEFFECTS_DESCRIPTION: "Show festive animations during special seasons (e.g. Christmas, New Year)",
	NOPERMISSION: "You do not have permission to change this setting",
	ACTIVITY_TEMPLATES: "Activity Templates",
	ACTIVITY_TEMPLATES_COMPANY: "Company-wide Activity Templates",
	ADD_TEMPLATE: "Add Template",
	EDIT_TEMPLATE: "Edit Template",
	DELETE_TEMPLATE: "Delete Template",
	DELETE_TEMPLATE_CONFIRM: "Are you sure you want to delete this template?",
	TEMPLATE_NAME: "Template Name",
	TEMPLATE_DESCRIPTION: "Description Text",
	ACTIVITYDESCRIPTION: "Activity description",
	TEMPLATE_STATUS: "Work Mode",
	TEMPLATE_OBJECTS: "Objects",
	TEMPLATE_SAVED: "Template saved",
	TEMPLATE_DELETED: "Template deleted",
	NO_TEMPLATES: "No templates yet",
	TEMPLATE_ITEMS_UNAVAILABLE: "Some items in this template are no longer assigned or accessible and will be ignored.",
	CONNECTED_ACCOUNTS: "Connected Accounts",
	CONNECTED_ACCOUNTS_DESC: "External accounts, such as Microsoft 365, to import appointments into TimeLite.",
	NO_CONNECTED_ACCOUNTS: "No accounts linked yet.",
	OAUTH_ADD_MICROSOFT: "Link Microsoft 365 Account",
	OAUTH_ADD_GOOGLE: "Link Google Account",
	OAUTH_DISCONNECT: "Disconnect",
	OAUTH_DISCONNECT_CONFIRM: "Are you sure you want to disconnect this account? All stored tokens will be deleted.",
	OAUTH_LINKED_SUCCESS: "Account linked successfully.",
	OAUTH_ERROR_GENERIC: "An error occurred while linking the account. Please try again.",
	PROVIDER_MICROSOFT: "Microsoft 365",
	PROVIDER_GOOGLE: "Google",
	NOTIFICATION_DEFAULT_PREFERENCES: "Notifications",
	NOTIFICATION_DEFAULT_PREFERENCES_TITLE: "Default Notification Settings",
	NOTIFICATION_DEFAULT_PREFERENCES_DESC: "Configure system-wide default delivery preferences for each notification type. Users can change these in their personal settings.",
	NOTIF_CHANNEL_MAIL: "Mail",
	NOTIF_CHANNEL_PUSH: "Push (App)",
	NOTIF_MODE_INSTANT: "Instant",
	NOTIF_MODE_DAILY: "Daily Summary",
	NOTIF_MODE_OFF: "Off",
	NOTIF_DAILY_SUMMARY_TIME: "Daily summary delivery time",
	NOTIFTYPE_TASK_ASSIGNED: "Task Assigned",
	NOTIFTYPE_TASK_REASSIGNED: "Task Reassigned",
	NOTIFTYPE_TASK_CLOSED: "Task Closed",
	NOTIFTYPE_TASK_REOPENED: "Task Reopened",
	NOTIFTYPE_TASK_OVERDUE: "Task Overdue",
	NOTIFTYPE_TASK_NOW_OPEN: "Task Now Open",
	NOTIFTYPE_REQUEST_RECEIVED: "Request Received",
	NOTIFTYPE_REQUEST_FORWARDED: "Request Forwarded",
	NOTIFTYPE_REQUEST_ANSWERED: "Request Answered",
	NOTIFTYPE_ACTIVITY_ERROR: "Activity Error",
	NOTIFTYPE_OBJECTITEM_ASSIGNED: "Object Assigned",
	NOTIFTYPE_OBJECTITEM_UNASSIGNED: "Object Unassigned",
	NOTIFTYPE_REPORT_FINISHED: "Report Generated",
	NOTIF_GROUP_TASKS: "Tasks",
	NOTIF_GROUP_REQUESTS: "Requests",
	NOTIF_GROUP_OBJECTS: "Objects",
	NOTIF_GROUP_ACTIVITIES: "Activities",
	NOTIF_GROUP_REPORTS: "Reports",
	NOTIF_USER_SETTINGS: "Notifications",
	NOTIF_PUSH_DEVICES: "Registered Push Devices",
	NOTIF_PUSH_DEVICES_EMPTY: "No push devices registered.",
	NOTIF_PUSH_DEVICE_REMOVE: "Remove device",
	NOTIF_PUSH_DEVICE_REMOVE_CONFIRM: "Are you sure you want to remove this device?",
	NOTIF_PUSH_DEVICE_ENABLE: "Enable push notifications for this device",
	NOTIF_PUSH_DEVICE_DISABLE: "Disable push notifications for this device",
	NOTIF_PUSH_DEVICE_SENDTEST: "Send test push notification",
	NOTIF_PUSH_DEVICE_TEST_SENT: "Test notification sent.",
	PRODUCT: "Product",
	UNLIMITED: "Unlimited",
	ASSIGNED: "Assigned",
	OVER_THE_LIMIT: "Over the limit",
	AVAILABLE: "Available",
	LAST_WEBCRON_RUN: "Last Webcron",
	WEBCRON_INTERVAL: "Interval",
	TOTAL_DB_SIZE: "Total DB size",
	WEBCRON_NEVER: "Never",
	REQUEST_LICENCE_CHANGES: "Request licence changes",
	LICENCE_CHANGE_REQUEST_MESSAGE: "I would like to request changes to the product licences.",
};

export default locale;
